import { AssetType } from '../../../../../types/api';

const parseAssetList = (
  assetList: string | null | undefined
): ReadonlyArray<string> => {
  if (!assetList) return [];
  return assetList
    .split(';')
    .map((value) => value.trim())
    .filter((value) => value.length > 0);
};

/** Empty/null is unrestricted; otherwise selected assets must all be in the list. */
const appliesToSelectedAssets = (
  appliesToAssets: string | null | undefined,
  selectedAssetTypes: ReadonlyArray<AssetType> = []
): boolean => {
  const restriction = parseAssetList(appliesToAssets);
  if (restriction.length === 0) return true;
  if (selectedAssetTypes.length === 0) return false;
  return selectedAssetTypes.every((assetType) =>
    restriction.includes(assetType)
  );
};

/** Empty/null excludes nothing. Hide when every selected asset is in the list. */
const isExcludedForSelectedAssets = (
  excludeForAssets: string | null | undefined,
  selectedAssetTypes: ReadonlyArray<AssetType> = []
): boolean => {
  const excluded = parseAssetList(excludeForAssets);
  if (excluded.length === 0 || selectedAssetTypes.length === 0) return false;
  return selectedAssetTypes.every((assetType) => excluded.includes(assetType));
};

const isVisibleForSelectedAssets = (
  appliesToAssets: string | null | undefined,
  excludeForAssets: string | null | undefined,
  selectedAssetTypes: ReadonlyArray<AssetType> = []
): boolean =>
  appliesToSelectedAssets(appliesToAssets, selectedAssetTypes) &&
  !isExcludedForSelectedAssets(excludeForAssets, selectedAssetTypes);

export const Fees = {
  appliesToSelectedAssets,
  isExcludedForSelectedAssets,
  isVisibleForSelectedAssets,
};
